import axios from "axios";

//https://api.gpartners.md
//https://apigpartners.amark.pro
let urlAPI = "https://api.gpartners.md";
let url = "https://gpartners.md";
let axiosInstance = axios.create({
  baseURL: urlAPI,
  headers: {
    Authorization: `Bearer ${window.localStorage.getItem("token")}`,
  },
});

export { urlAPI, url, axiosInstance };
